export default {
  title: 'Login / Register',
  subtitle: 'Phone / Email verification for login, new users automatically create an account',
  tabUsername: 'Username',
  tabEmail: 'Email',
  tabPhone: 'Phone',
  usernamePlaceholder: 'Enter username',
  emailPlaceholder: 'Enter email',
  phonePlaceholder: 'Enter phone number',
  passwordLabel: 'Password',
  passwordPlaceholder: 'Enter password',
  verifyCode: 'Verification Code',
  emailCodePlaceholder: 'Email verification code',
  smsCodePlaceholder: 'SMS verification code',
  getCode: 'Get Code',
  rememberMe: 'Remember me',
  forgotPassword: 'Forgot password?',
  submit: 'Login / Register',
  loading: 'Logging in...',
  loginSuccess: 'Login successful, entering...',
  quickLogin: 'Quick Login / Register',
  socialUnavailable: 'This login method is not available yet',
  metamaskNotInstalled: 'MetaMask not detected. Please install the wallet extension first.',
  metamaskRejected: 'Wallet authorization / signing was cancelled',
  metamaskConnectFailed: 'Failed to connect wallet, please try again',
  metamaskRequestPending: 'Please confirm or cancel the pending request in MetaMask',
  metamaskAccountChanged: 'Wallet account changed, please start the login again',
  metamaskRateLimited: 'Too many attempts, please try again later',
  metamaskBanned: 'This account has been disabled. Please contact support.',
  agreementPrefix: 'Logging in means agreeing to',
  userAgreement: 'User Agreement',
  and: 'and',
  privacyPolicy: 'Privacy Policy',
  agreementSuffix: ', and being over 18 years old',
  forgotTitle: 'Recover Password',
  forgotSubtitle: 'Username accounts require verification via bound phone / email',
  accountLabel: 'Account(Username)',
  accountPlaceholder: 'Enter registered username',
  boundContactLabel: 'Bound Phone / Email',
  boundContactPlaceholder: 'Enter bound phone (with country code, e.g. +86) or email',
  sixDigitCodePlaceholder: '6-digit code',
  nextStep: 'Next',
  newPasswordLabel: 'New Password',
  newPasswordPlaceholder: '8-64 characters, letters & numbers',
  confirmPasswordLabel: 'Confirm New Password',
  confirmPasswordPlaceholder: 'Re-enter new password',
  confirmReset: 'Confirm Reset',
  resetSuccess: 'Password reset successfully, please log in again',
  rememberedText: 'Remembered it?',
  backToLogin: 'Back to login',
  errorUsernameRequired: 'Please enter your username',
  errorUsernameInvalid: 'Username must be 4-20 letters, digits or underscores',
  errorPasswordLetterDigit: 'Password must contain both letters and digits',
  errorEmailInvalid: 'Please enter a valid email address',
  errorEmailCodeRequired:
    'Please enter the 6-digit email verification code (error example: incorrect code)',
  errorPhoneInvalid: 'Please enter a valid phone number',
  errorPhoneCodeRequired: 'Please enter the 6-digit SMS verification code',
  errorPasswordRequired: 'Please enter your password',
  errorPasswordLength: 'Password must be 8-64 characters',
  errorPasswordTooShort: 'Password must be at least 6 characters',
  errorAgreementRequired: 'Please agree to the user agreement',
  errorContactRequired: 'Enter a valid bound phone (with country code) or email',
  errorLoginFailed: 'Login failed, please try again later',
  errorNetwork: 'Network error, please check your connection and try again',
  errorNewPasswordRequired:
    'New password must be 8–64 characters and contain both letters and numbers',
  errorNewPasswordInvalid: 'Password must be 8-64 characters with letters and numbers',
  errorConfirmPasswordMismatch: 'Passwords do not match',
  errorResetFailed: 'Failed to reset password, please try again later',
  codeSendLimited: 'Too many code requests — please try again in 10 minutes',
}
